var InstanceQueryKeys={instance:['instance']};export{InstanceQueryKeys};